import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, MenuController, ModalController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { Preferences } from '@capacitor/preferences';
import { DataService } from 'src/app/services/data.service';
import { LoaderService } from 'src/app/services/loader.service';
import { HttpClient } from '@angular/common/http';

import { FormBuilder, FormGroup } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { ForgotPasswordPage } from 'src/app/pages/forgot-password/forgot-password.page';
import { ChangeClientPage } from 'src/app/modals/change-client/change-client.page';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { PlatformService } from 'src/app/platform.service';
import { TicketLookupPage } from 'src/app/modals/ticket-lookup/ticket-lookup.page';

import { LanguageService } from 'src/app/services/language.service';
import { ToastService } from 'src/app/services/toast.service';
import { PaymentsService } from 'src/app/payments.service';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Capacitor } from '@capacitor/core';
import { EMPTY } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PagecontentComponent } from 'src/app/components/pagecontent/pagecontent.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit,AfterViewInit {
  isContentEmpty = false;
  environment = environment
  errors = [];
  counter = 0;
  authSetting;
  saveCredentials = false
  loginForm: FormGroup = new FormGroup({})
  emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  typingEmail = false;
  typingPassword = true;
  typingUsername = true;
  @ViewChild('pagecontent') pagecontent: PagecontentComponent;

  constructor(
    private errorHandlerSRV: ErrorHandlerService,
    private iab: InAppBrowser,
    public paymentSRV: PaymentsService,
    private cd: ChangeDetectorRef,
    private toastSRV: ToastService,
    public platformSRV: PlatformService,
    private errorSRV: ErrorHandlerService,
    public modalController: ModalController,
    private appComp: AppComponent,
    private fb: FormBuilder,
    private http: HttpClient,
    private loaderService: LoaderService,
    public dataService: DataService,
    private router: Router,
    private alertController: AlertController,
    private translate: TranslateService,
  ) {


    this.loginForm = this.fb.group({
      "login": "",
      "password": "",

    })
  }
  ngAfterViewInit() {
    this.pagecontent.contentLoaded.subscribe(isContentEmpty => {
      this.isContentEmpty = !isContentEmpty;
    });
  }
  openScanner() {
    this.router.navigateByUrl('/qrscanner')
  }
  async openRealTimeParking() {
    this.router.navigateByUrl('/realtimemodal')
  }
  
  async changeClient() {

    const mobileModal = await this.modalController.create({
      component: ChangeClientPage,
      breakpoints: [0.5, 0.8, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-mobile-normal'
    })
    const tabletModal = await this.modalController.create({
      component: ChangeClientPage,
      breakpoints: [0.5, 0.8, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-tablet-normal'
    })
    mobileModal.onDidDismiss().then(data => {
      if (data.data == "refresh") {
        this.ionViewDidEnter()
      }
    })
    tabletModal.onDidDismiss().then(data => {
      if (data.data == "refresh") {
        this.ionViewDidEnter()
      }
    })

    if (this.platformSRV.device == 'mobile') {
      return await mobileModal.present();
    } else if (this.platformSRV.device == 'tablet') {
      return await tabletModal.present();
    }
  }
  async lookupTicket() {
    const desktopModal = await this.modalController.create({
      component: TicketLookupPage,
      breakpoints: [0.5, 0.8, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long'
    });
    const mobileModal = await this.modalController.create({
      component: TicketLookupPage,
      breakpoints: [0.5, 0.8, 1],
      initialBreakpoint: 1,
      cssClass: "modal-mobile-normal"
    })
    const tabletModal = await this.modalController.create({
      component: TicketLookupPage,
      breakpoints: [0.5, 0.8, 1],
      initialBreakpoint: 1,
      cssClass: "modal-tablet-normal"
    })
    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
    modal.present()



  }
  async openForgotUsernamePasswordModal() {
    this.router.navigate(['/forgotpassword'])

  }
  openLoginSource(loginSource) {

    const browser = this.iab.create(loginSource['url'], '_blank', this.dataService.browserOptionsOptions + ',clearsessioncache=yes')
    var connectedToUrlDetails = new URL(this.dataService.apiUrl)
    browser.on('loadstart').subscribe(async browserResult => {
      var urlDetails = new URL(browserResult.url)
      if(connectedToUrlDetails.hostname == urlDetails.hostname){
        var csrftoken
        csrftoken = await browser.executeScript({
          code: `document.querySelector("meta[name='csrf-token']").content`
        })

        browser.close()
        this.loaderService.showLoader(this.translate.instant('keys.data.common.loading') || 'Loading...')
        this.dataService.getData('api/v1/user/profile').subscribe(async userData => {
          setTimeout(() => {
            this.loaderService.dismissLoader()
          }, 1500);
          if (userData['status'] == 'success') {
            this.proceed(userData)
          }
        })

      }
    })
  }
  ionViewDidEnter() {
    this.dataService.autoLogin().subscribe({
      next: res => {
      

      },
      error: (error) => {
      
        if (error?.error_code==2022) {
          this.getProfileAfterLogin(error)
        } else {
          this.dataService.storeData(`passwordEntered`,{})
          this.dataService.isAuthenticated.next(false)
        }
      }
    })



    this.dataService.getDisclaimers()
    this.dataService.getSettings().subscribe((res) => {


      this.dataService.settings = res['settings'];
      this.authSetting = res['auth']

    });
    if (Capacitor.isNativePlatform()) {


      this.dataService.getStoredData({ key:environment.clientsKey }).then(value => {
        if (value) {
          for (
            var i = 0;
            i < value.clients.length;
            i++
          ) {
            if (value.clients[i].lastSelected == true) {
              this.dataService.selectedClient = value.clients[i]

            }
          }
        }
      })

    }

    this.appComp.changeDetectorRef.detectChanges()

  }


  ngOnInit() {
    
    
    // })
    // this.folder = this.activatedRoute.snapshot.paramMap.get('id');
  }
  enableLogin() {
    if (this.loginForm.value['login'] !== "" && this.loginForm.value['login'].match(this.emailPattern)) {
      this.typingEmail = true;
      this.typingUsername = false;
    } else if (this.loginForm.value['login'] !== "" && !this.loginForm.value['login'].match(this.emailPattern)) {
      this.typingUsername = true;
      this.typingEmail = false;
    } else {
      this.typingEmail = false;
      this.typingUsername = true;
    }
    // if(this.model.password=="" || this.model.login==""){
    //   this.buttonDisabled=true
    //   } else if(this.model.password!=="" && this.model.login!=="") {
    //       this.buttonDisabled=false;
    //   } 

  }
  changeLanguage(lang){
    this.dataService.getData('lang/' +lang ).subscribe({
      next:async response=>{
        if(response['status']=="success"){
          this.dataService.changeLanguage(lang)
        } else {
          this.errorHandlerSRV.displayErrorMessage(response,true)
        }
    },error:err=>{
      this.errorHandlerSRV.displayErrorMessage(err,true)
    }
  
  })
  }
  proceed(res) {
    this.dataService.getData('api/v1/user/profile').subscribe(async userData => {

      if (userData['status'] == 'success') {
        if (userData['profile']['company_manager'] == '1') {
          this.dataService.isCompanyManager = true
        } else {
          this.dataService.isCompanyManager = false
        }
        this.dataService.storeData(environment.storageKey,
          {
            user: userData['profile'],
            csrf_token: res['state'].csrf_token,

          });
        this.dataService.user = userData['profile'];
        if (userData['profile']['language']) {
          this.changeLanguage(userData['profile']['language'])
        }

        this.dataService.isAuthenticated.next(true);
        this.dataService.cartCounter = undefined
        
        this.router.navigate(['home']);
        this.dataService.showVersionUpdatePrompt()
        this.loginForm.controls['login'].setValue("")
        this.loginForm.controls['password'].setValue("")
        this.loaderService.dismissLoader()
      } 




    })
  }
  submitOnEnter(){
    if(this.loginForm.valid){
      this.onLogin()
    }
  }
  async onLogin() {
    this.errors = []
    this.dataService.getStoredData({ key: 'client' }).then(client => {
      this.loaderService.showLoader(this.translate.instant('keys.data.users_login.logging_in') || 'Logging in...')
      this.dataService.postLogin(this.loginForm.value)
        .subscribe({
          next: async (res: any) => {


            if (res['status'] === 'success') {
              
              if (res['message'] && res['code']) {
                this.toastSRV.presentToast(res['message'])
              }

              
              if(res?.user['company_manager']=='1'){
                this.dataService.isCompanyManager=true
              } else {
                this.dataService.isCompanyManager=false
              }
              this.dataService.storeData(environment.storageKey,
              {
                user:res?.user,
                  csrf_token: res['state'].csrf_token,
               
              });
              this.dataService.user = res?.user;
              this.changeLanguage(res?.user['language'])
              this.dataService.isAuthenticated.next(true);
              this.dataService.cartCounter = undefined
             
              
              this.router.navigate(['home']);
              this.loginForm.controls['login'].setValue("")
              this.loginForm.controls['password'].setValue("") 
              this.dataService.showVersionUpdatePrompt()
              
            this.loaderService.dismissLoader()
            }
            if (res['status'] === 'error') {
              this.loaderService.dismissLoader()
              if (res?.message) {
                this.errorHandlerSRV.displayErrorMessage(res['message'], true)
              }

              this.dataService.isAuthenticated.next(false);
              this.dataService.storeData(`passwordEntered`,{})
            }
          },
          error: (error) => {
            if (error?.error_code==2022) {
              this.getProfileAfterLogin(error)
            } else {
              this.dataService.isAuthenticated.next(false)
            }
            this.errorHandlerSRV.displayErrorMessage(error, false).then(response => {
              this.errors = response['fields']
            })
            this.dataService.isAuthenticated.next(false);
            this.dataService.storeData(`passwordEntered`,{})
          }

        });
    })

  }
  getProfileAfterLogin(res) {
    this.dataService.getData('api/v1/user/profile').subscribe({
      next:async (userData:any)=>{
        if(userData['status']=='success'){
         this.processProfileInfo(res,userData)
          
           
            
         
          this.router.navigate(['home']);
          this.loginForm.controls['login'].setValue("")
          this.loginForm.controls['password'].setValue("") 
          this.dataService.showVersionUpdatePrompt()
          
        this.loaderService.dismissLoader()
        } 
        
      },
      error:err=>{
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
     
      
     
      
      
    })
  }
  processProfileInfo(res,userData){
    if(userData['profile']['company_manager']=='1'){
      this.dataService.isCompanyManager=true
    } else {
      this.dataService.isCompanyManager=false
    }
    this.dataService.storeData(environment.storageKey,
    {
      user:userData['profile'],
        csrf_token: res['state'].csrf_token,
     
    });
    this.dataService.user = userData['profile'];
    this.changeLanguage(userData['profile']['language'])
    this.dataService.isAuthenticated.next(true);
    this.dataService.cartCounter = undefined
    this.dataService.getSettings().subscribe((res) => {
      this.dataService.settings = res['settings'];
    
     
      
    });
    this.router.navigate(['home']);
    this.loginForm.controls['login'].setValue("")
    this.loginForm.controls['password'].setValue("") 
    this.dataService.showVersionUpdatePrompt()
    
  this.loaderService.dismissLoader()
  }
 
  
}
